




















import Vue from "vue";
import { authService } from "@/common/services/AuthService";
import FirebaseSignIn from "@/common/components/FirebaseSignIn.vue";

export default Vue.extend({
  name: "ProductLocation",

  components: {
    FirebaseSignIn,
  },

  data() {
    return {
      authService: authService,
    };
  },
});
